import { Component, OnInit, Input } from '@angular/core';
import { StaffService } from '../../../injections/staff.service';


@Component({
    selector: 'main-staff',
    templateUrl: '../templates/main-staff.html'
})

export class MainStaffComponent implements OnInit {
    
    public staff: Array<object>;
    selected: number = null;
    public staffSelected = {}; 
    public person = {};
    constructor(private staffService: StaffService) { 
        this.staffService.getUsers().subscribe( data => {
            this.staff = data;
        });
    }

    public manageStaffData(object) {
        //console.log(object);
        switch(object["action"]){
            case "update": this.updateManagerUser(object["data"]);
            break;

            case "remove": this.removeManagerUser(object["id"]);
            break;

            case "create": this.createManagerUser(object["data"]);
            break;
        }
    }

    public showDataForm(object) {
        //console.log(object);
        if(object["action"] == "edit"){
            this.staffSelected = object["data"];
        }else if(object["action"] == "create"){
            this.staffSelected = null;
        }
    }

    private updateManagerUser(data: object){
        this.staffService.updateUser(data).subscribe( status => {
            if(status == "OK"){
                this.staff.forEach( item => {
                    if(item["id"] == data["id"]){
                        item = data;
                    }
                }) 
            }
        })
    }

    private removeManagerUser(id: string){
        //id.toString();
        this.staffService.removeUser(id).subscribe( status => {
            if(status == "OK"){
                this.staff.forEach( (item, index) => {
                    if(item["id"] == id){
                        this.staff.splice(index,1);
                    }
                }) 
            }
        })
    }

    private createManagerUser(data: object){
        //id.toString();
        this.staffService.createUser(data).subscribe( result => {
            if(result != null){
                data["id"] = result;
                this.staff.push(data); 
            }
        })
    }

    ngOnInit() {

    }
}


// WEBPACK FOOTER //
// ./src/app/modules/staff/components/main-staff.component.ts